<template>
  <div>
    <div class="rj-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: 'DistributorOrderList' }">
          已办订单
        </el-breadcrumb-item>
        <el-breadcrumb-item>详细信息</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <base-info :document-i-d="documentID" @initedBaseInfo="initedBaseInfo" />
    <rj-tabs v-model="tabsActive">
      <rj-tab-pane name="1" label="分销商产品及价格">
        <distributor-product :document-i-d="documentID" />
      </rj-tab-pane>
      <rj-tab-pane name="2" label="集成商产品及价格">
        <integrators-product :document-i-d="documentID" />
      </rj-tab-pane>
      <div style="margin-left: 10px">
        <el-button type="primary" :loading="submitLoading" @click="submit">
          导出订单信息表
        </el-button>
        <a ref="down" />
      </div>
    </rj-tabs>
  </div>
</template>
<script type="es6">
import baseInfo from './baseInfo';
import distributorProduct from './distributorProduct';
import integratorsProduct from './integratorsProduct';
import tabs from '@/components/Tabs/tabs';
import tabPane from '@/components/Tabs/tabPane';
import axios from '@/API';
export default {
  data () {
    return {
      tabsActive: '1',
      baseInfo: null,
      submitLoading: false
    };
  },
  props: {
    documentID: {
      type: String,
      required: true
    }
  },
  components: {
    baseInfo,
    distributorProduct,
    integratorsProduct,
    'rj-tab-pane': tabPane,
    'rj-tabs': tabs
  },
  computed: {},
  methods: {
    initedBaseInfo (val) {
      this.baseInfo = val;
    },
    submit () {
      this.submitLoading = true;
      axios.get('/export/getExportOrderInfo?documentID=' + this.documentID, {
        responseType: 'blob'// 服务器返回的数据类型
      }).then((res) => {
        this.submitLoading = false;
        const content = res.data;
        const blob = new Blob([content]);// 构造一个blob对象来处理数据
        const fileName = '订单信息表.xls';

        // 对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
        // IE10以上支持blob但是依然不支持download
        if (window.navigator.msSaveOrOpenBlob) { // 支持a标签download的浏览器
          navigator.msSaveBlob(blob, fileName);
        } else { // 其他浏览器
          const link = document.createElement('a');// 创建a标签
          link.download = fileName;// a标签添加属性
          link.style.display = 'none';
          link.href = URL.createObjectURL(blob);
          document.body.appendChild(link);
          link.click();// 执行下载
          URL.revokeObjectURL(link.href); // 释放url
          document.body.removeChild(link);// 释放标签
        }
      }).catch(() => {
        this.submitLoading = false;
      });
    }
  },
  mounted () {
  }
};
</script>
<style lang="scss">
  .rj-breadcrumb{
  .rj-tabs-body{
    padding-bottom:0!important;
  }
  }
</style>
